import { CircularProgress, Stack, Typography } from '@mui/material'
import { useLazyGetMySocialOrdersPageQuery } from '../../../../api/socialOrders'
import { SocialOrdersList } from '../../../../components/SocialOrders/SocialOrdersList'
import { useSocialOrdersQueryArgs } from '../../../../hooks/useSocialOrdersQueryArgs'
import { useSocialOrdersWindowedPage } from '../../../../hooks/useSocialOrdersWindowedPage'

export const SocialOrdersMine = () => {
  const { queryArgs, resetKey } = useSocialOrdersQueryArgs()
  const [loadSocialOrdersPage] = useLazyGetMySocialOrdersPageQuery()
  const { items, hasMore, isInitialLoading, isFetchingMore, isError, loadMore } =
    useSocialOrdersWindowedPage(resetKey, loadSocialOrdersPage, queryArgs)

  if (isInitialLoading && items.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError) {
    return (
      <Typography color="error" textAlign="center" px={2}>
        Не удалось загрузить ваши социальные заказы
      </Typography>
    )
  }

  return (
    <SocialOrdersList
      socialOrders={items}
      hasMore={hasMore}
      isLoadingMore={isFetchingMore}
      onLoadMore={loadMore}
      emptyMessage="У вас пока нет социальных заказов"
    />
  )
}
